export var PreferencesTypeEnum;
(function (PreferencesTypeEnum) {
    PreferencesTypeEnum["SUBSCRIBER_WORKFLOW"] = "SUBSCRIBER_WORKFLOW";
    PreferencesTypeEnum["SUBSCRIBER_GLOBAL"] = "SUBSCRIBER_GLOBAL";
    PreferencesTypeEnum["USER_WORKFLOW"] = "USER_WORKFLOW";
    PreferencesTypeEnum["WORKFLOW_RESOURCE"] = "WORKFLOW_RESOURCE";
})(PreferencesTypeEnum || (PreferencesTypeEnum = {}));
